import React, {HTMLAttributes, useMemo} from "react";
import {usePrissoknader} from "../../api/prissoknader";
import {ResoknadMedlemskap, useResoknadStatus} from "../../api/resoknadstatus";
import LoadingSpinner from "../LoadingSpinner";
import {PktMessagebox} from "@oslokommune/punkt-react";
import {Link} from "react-router-dom";

export const AlertResoker = (attrs: HTMLAttributes<HTMLDivElement>) => {
    const [prissoknader, prissoknaderStatus] = usePrissoknader()
    const [medlemskap, medlemskapStatus] = useResoknadStatus()

    const harAktivResoknad = useMemo(() => {
        return prissoknader?.some(prissoknad => {
            return prissoknad.søknadstype === 'RESØKNAD' && (
                prissoknad.søknadsstatus === 'OVERSENDT_SAKSBEHANDLER' || prissoknad.søknadsstatus === 'VENTER_PÅ_SKATTEOPPGJØR'
            )
        })
    }, [prissoknader])

    if (prissoknaderStatus === 'pending' || medlemskapStatus === 'pending') {
        return <LoadingSpinner/>
    }

    if (medlemskap === "INGEN") {
        return ""
    }


    return (
        <div {...attrs}>
            {medlemskap === ResoknadMedlemskap.AKTIV && !harAktivResoknad && (
                <AlertResoknadActiveNoResoknad/>
            )}
            {medlemskap === ResoknadMedlemskap.AKTIV && harAktivResoknad && (
                <AlertResoknadActiveHasResoknad/>
            )}
            {medlemskap === ResoknadMedlemskap.TRUKKET_SEG && (
                <AlertResoknadNotActive/>
            )}
        </div>
    )
};

const AlertResoknadActiveNoResoknad = () => {
    return (
        <PktMessagebox
            compact
            title='Vi søker om redusert barnehagepris for deg'
            skin="beige"
        >
            Du eller noen i husholdningen din har tidligere søkt om redusert barnehagepris. Oslo kommune vil derfor søke
            på deres vegne for neste barnehageår. Har dere ikke lenger behov for redusert
            barnehagepris?{" "}
            <Link className="pkt-link" to="/barnehagepris/avsluttsoknad">
                Stopp søknadene her.
            </Link>
        </PktMessagebox>
    )
}

// Todo: fjern denne etter din barnehagepris er prodsatt
const AlertResoknadActiveHasResoknad = () => {
    return (
        <PktMessagebox
            title='Vi søker om redusert barnehagepris for deg'
            compact
            skin="green"
        >
            <p>
                Du, eller noen i husholdningen din, har tidligere søkt om redusert barnehagepris. Oslo kommune har
                derfor laget en søknad for dere for neste barnehageår. Denne er nå til behandling.
            </p>
            <p>
                Har dere ikke lenger behov for redusert barnehagepris?{" "}
                <Link className="pkt-link" to="/barnehagepris/avsluttsoknad">
                    Stopp behandling av søknaden her.
                </Link>
            </p>
        </PktMessagebox>
    )
}

const AlertResoknadNotActive = () => {
    return (
        <PktMessagebox
            skin={"beige"}
            compact
            title='Du har ingen aktive søknader'
        >
            Du har tidligere søkt om redusert barnehagepris, men har stoppet alle framtidige søknader. Det betyr
            at dere må søke på nytt selv hvis dere får behov for lavere barnehagepris igjen.
            <p>
                Har du spørsmål eller mener det har skjedd en feil, ring Oslo kommunes kontaktsenter for barnehage på
                telefon <span style={{ whiteSpace: 'nowrap' }}>23 68 08 30</span>.
            </p>
        </PktMessagebox>
    )
}

